module.exports = "<p>\n  pricing-booking works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/pricing-booking.component.html
// module id = ./src/app/component/pricing-booking/pricing-booking.component.html
// module chunks = main